let config = {};
const hostname = window.location.hostname;
const href = window.location.href;

switch (hostname) {
    case '0.0.0.0':
        config = require('./config.dev')();
        break;
    case 'm.black-unique.com':
        config = require('./config.prod')();
        break;
    case 'h5-promo.black-unique.com':
        config = require('./config.prod')();
        break;
    case 'm.haoyintechnology.com':
        config = require('./config.mini')();
        break;
    default:
        config = require('./config.prod')();
        // config = require('./config.dev')();
        break;
}

if (/box/.test(hostname)) {
    let prefix = 'box';
    let str1 = hostname.split('.')[0];
    if (str1 && str1.split('-')[0]) {
        prefix = str1.split('-')[0];
    }
    config = require('./config.box')(prefix);
}

if (/test/.test(hostname)) {
    let prefix = 'test';
    let str1 = hostname.split('.')[0];
    if (str1 && str1.split('-')[0]) {
        prefix = str1.split('-')[0];
    }
    config = require('./config.test')(prefix);
}

// 域名为 h5-ppp开头的，表示是活动的域名
let isPromoOrigin = /^h5-ppp\./.test(hostname) || hostname === 'h5-promo.black-unique.com';
if (isPromoOrigin) {
    let prefix = '';

    let boxMatch = href.match(/\/box\d*\//);
    if (boxMatch) {
        prefix = boxMatch[0].replace(/\//g, '');
        config = require('./config.box')(prefix);
    }

    let testMatch = href.match(/\/test\d*\//);
    if (testMatch) {
        prefix = testMatch[0].replace(/\//g, '');
        config = require('./config.test')(prefix);
    }
}

export default config;
